import fieldsEN from "./en/fields.json";
import fieldsFR from "./fr/fields.json";
import fieldsAR from "./ar/fields.json";

import messagesEN from "./en/messages.json";
import messagesFR from "./fr/messages.json";
import messagesAR from "./ar/messages.json";

import modelsEN from "./en/models.json";
import modelsFR from "./fr/models.json";
import modelsAR from "./ar/models.json";

export const messages = {
    ar: {
        fields: fieldsAR,
        messages: messagesAR,
        models: modelsAR,
    },
    en: {
        fields: fieldsEN,
        messages: messagesEN,
        models: modelsEN,
    },
    fr: {
        fields: fieldsFR,
        messages: messagesFR,
        models: modelsFR,
    },
};
